import * as React from 'react';
const LocationTarget = (props: any) => {
  const { fillColor = '#1A73E9' } = props || {};
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
      <mask
        id="a"
        width={20}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill="#D9D9D9" d="M0 0h20v20H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill={fillColor}
          d="M9.375 18.5v-1.442c-1.736-.178-3.197-.861-4.384-2.048-1.187-1.187-1.87-2.649-2.048-4.385H1.5v-1.25h1.443c.178-1.736.86-3.197 2.048-4.384 1.187-1.187 2.648-1.87 4.384-2.048V1.5h1.25v1.443c1.736.178 3.198.86 4.385 2.048 1.187 1.187 1.87 2.648 2.048 4.384H18.5v1.25h-1.442c-.178 1.736-.861 3.198-2.048 4.385-1.187 1.187-2.649 1.87-4.385 2.048V18.5h-1.25ZM10 15.834c1.611 0 2.986-.57 4.125-1.709 1.14-1.138 1.709-2.513 1.709-4.125 0-1.61-.57-2.986-1.709-4.125C12.986 4.737 11.611 4.167 10 4.167c-1.61 0-2.986.57-4.125 1.708C4.736 7.015 4.167 8.39 4.167 10c0 1.612.57 2.987 1.708 4.125 1.14 1.14 2.514 1.709 4.125 1.709Zm0-2.917a2.808 2.808 0 0 1-2.06-.857A2.809 2.809 0 0 1 7.084 10c0-.802.285-1.488.856-2.06A2.809 2.809 0 0 1 10 7.085c.802 0 1.489.285 2.06.857.571.57.857 1.257.857 2.06 0 .802-.286 1.488-.857 2.06a2.809 2.809 0 0 1-2.06.856Zm0-1.25c.459 0 .85-.163 1.177-.49.327-.326.49-.718.49-1.177 0-.458-.163-.85-.49-1.177A1.605 1.605 0 0 0 10 8.333c-.458 0-.85.164-1.177.49-.326.327-.49.72-.49 1.177 0 .459.164.851.49 1.178.327.326.719.49 1.177.49Z"
        />
      </g>
    </svg>
  );
};
export default LocationTarget;
